import {
  DeleteOutlined,
  MinusCircleOutlined,
  PlusOutlined,
} from '@ant-design/icons';
import { styled } from '@stitches/configed';
import {
  Button,
  Select,
  Form,
  InputNumber,
  Tooltip,
  Row,
  Col,
  FormInstance,
} from 'antd';
import { FormListFieldData } from 'antd/lib/form/FormList';
import { ReactNode, useState } from 'react';
import { paymentMethods } from '..';

const GroupContainer = styled('div', {
  backgroundColor: '$background',
  padding: 16,
  borderRadius: 5,
  border: '1px solid $border',
  width: '100%',
});

type Props = {
  form: FormInstance;
};
const ConditionsSetting = ({ form }: Props) => {
  return (
    <Form.List
      name="rules"
      // initialValue={[[{ field: Object.keys(ruleAttributeMap)[0] }]]}
      // rules={[
      //   {
      //     validator: async (_, values) => {
      //       // check array, array in array, fields in object
      //       // if (
      //       //   !values ||
      //       //   values.length === 0 ||
      //       //   values[0].length === 0 ||
      //       //   !values[0][0].field ||
      //       //   !values[0][0].operator ||
      //       //   !values[0][0].value
      //       // ) {
      //       //   return Promise.reject(
      //       //     new Error('Vui lòng thêm ít nhất một Quy tắc'),
      //       //   );
      //       // }
      //     },
      //   },
      // ]}
    >
      {(fields, { add, remove: groupRemove }, { errors }) => (
        <>
          {fields.map((field, groupIndex) => (
            <Form.Item
              key={field.key}
              label={groupIndex === 0 ? 'Quy tắc giảm giá' : ''}
            >
              <div style={{ display: 'flex' }}>
                <div style={{ width: '100%' }}>
                  <Form.List name={[field.name]}>
                    {(fields, { add, remove }) => (
                      <GroupContainer>
                        {fields.map((field) => (
                          <RuleRow
                            indexGroup={groupIndex}
                            form={form}
                            key={field.key}
                            field={field}
                            remove={remove}
                          />
                        ))}
                        <Form.Item>
                          <div style={{ display: 'flex' }}>
                            <Button
                              type="dashed"
                              onClick={() => add()}
                              block
                              icon={<PlusOutlined />}
                            >
                              Và
                            </Button>
                            <Button
                              type="text"
                              danger
                              icon={<DeleteOutlined />}
                              onClick={() => groupRemove(field.name)}
                            >
                              Xoá nhóm
                            </Button>
                          </div>
                        </Form.Item>
                      </GroupContainer>
                    )}
                  </Form.List>
                </div>
              </div>
            </Form.Item>
          ))}
          <Form.Item>
            <Button
              type="dashed"
              onClick={() => add()}
              block
              icon={<PlusOutlined />}
            >
              {fields.length === 0 ? 'Thêm quy tắc giảm giá' : 'Hoặc'}
            </Button>
            <Form.ErrorList errors={errors} />
          </Form.Item>
        </>
      )}
    </Form.List>
  );
};

type Operator = {
  value: string;
  label: string;
};
type SaleRule = {
  value: string;
  label: string;
  operator: Operator[];
  unit?: string;
  valueComponent: ReactNode;
};
export const saleRules: Array<SaleRule> = [
  {
    value: 'base_total',
    label: 'Tiền mua hàng',
    operator: [
      { value: '==', label: 'Bằng' },
      { value: '>', label: 'Lớn hơn' },
      { value: '>=', label: 'Lớn hơn hoặc bằng' },
      { value: '<', label: 'Nhỏ hơn' },
      { value: '<=', label: 'Nhỏ hơn hoặc bằng' },
    ],
    unit: 'VNĐ',
    valueComponent: (
      <InputNumber
        addonAfter="VNĐ"
        formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
        parser={(value) => value?.replace(/\$\s?|(,*)/g, '') || 0}
        placeholder="0"
      />
    ),
  },
  {
    value: 'shipping_fee',
    label: 'Phí vận chuyển',
    operator: [
      { value: '==', label: 'Bằng' },
      { value: '>', label: 'Lớn hơn' },
      { value: '>=', label: 'Lớn hơn hoặc bằng' },
      { value: '<', label: 'Nhỏ hơn' },
      { value: '<=', label: 'Nhỏ hơn hoặc bằng' },
    ],
    unit: 'VNĐ',
    valueComponent: (
      <InputNumber
        addonAfter="VNĐ"
        formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
        parser={(value) => value?.replace(/\$\s?|(,*)/g, '') || 0}
        placeholder="0"
      />
    ),
  },
  {
    value: 'distance',
    label: 'Khoảng cách',
    operator: [
      { value: '==', label: 'Bằng' },
      { value: '>', label: 'Lớn hơn' },
      { value: '>=', label: 'Lớn hơn hoặc bằng' },
      { value: '<', label: 'Nhỏ hơn' },
      { value: '<=', label: 'Nhỏ hơn hoặc bằng' },
    ],
    unit: 'Mét',
    valueComponent: <InputNumber addonAfter="Mét" placeholder="0" />,
  },
  {
    value: 'payment_method',
    label: 'Phương thức thanh toán',
    operator: [{ value: '==', label: 'Là' }],
    valueComponent: (
      <Select>
        {paymentMethods.map((x) => {
          return (
            <Select.Option key={x.value} value={x.value}>
              {x.label}
            </Select.Option>
          );
        })}
      </Select>
    ),
  },
];

type RuleRowProps = {
  form: FormInstance;
  indexGroup: number;
  field: FormListFieldData;
  remove: (input: number | number[]) => void;
};
const RuleRow = ({ form, indexGroup, field, remove }: RuleRowProps) => {
  const currentSaleRules = form.getFieldValue('rules');
  const [saleRule, setSaleRule] = useState<SaleRule>(
    saleRules.find(
      (x) => x.value === currentSaleRules[indexGroup][field.key]?.attribute,
    ) || saleRules[0],
  );
  // console.log()
  return (
    <Row key={field.key} gutter={[8, 8]} align="middle">
      <Col xs={24} md={8}>
        <Form.Item
          name={[field.name, 'attribute']}
          initialValue={saleRule.value}
        >
          <Select
            onChange={(value) => {
              const saleRule = saleRules.find((x) => x.value === value);
              if (saleRule) {
                setSaleRule(saleRule);
                const currentSaleRules = form.getFieldValue('rules');
                currentSaleRules[indexGroup][field.key] = {
                  attribute: saleRule.value,
                  operator: saleRule.operator[0] && saleRule.operator[0].value,
                  value:
                    saleRule.value === 'payment_method'
                      ? paymentMethods[0].value
                      : undefined,
                };
                form.setFieldsValue({
                  rules: currentSaleRules,
                });
              }
            }}
          >
            {saleRules.map((x) => {
              return (
                <Select.Option key={x.value} value={x.value}>
                  {x.label}
                </Select.Option>
              );
            })}
          </Select>
        </Form.Item>
      </Col>
      <Col xs={24} md={6}>
        <Form.Item
          name={[field.name, 'operator']}
          initialValue={saleRule.operator && saleRule.operator[0].value}
        >
          <Select>
            {saleRule.operator.map((x) => {
              return (
                <Select.Option key={x.value} value={x.value}>
                  {x.label}
                </Select.Option>
              );
            })}
          </Select>
        </Form.Item>
      </Col>
      <Col xs={24} md={9}>
        <Form.Item
          key={field.key}
          name={[field.name, 'value']}
          // initialValue={
          //   saleRule.value === 'payment_method'
          //     ? paymentMethods[0].value
          //     : undefined
          // }
        >
          {saleRule.valueComponent}
        </Form.Item>
      </Col>
      <Col xs={24} md={1} style={{ textAlign: 'center' }}>
        <Form.Item>
          <Tooltip title="Xoá">
            <MinusCircleOutlined onClick={() => remove(field.name)} />
          </Tooltip>
        </Form.Item>
      </Col>
    </Row>
  );
};

export default ConditionsSetting;
